import { FailedToGetData, Loading, MapMarkerCurrentPosition } from 'src/components/_commons';
import { FC, useEffect, useState } from 'react';
import { generalBlue, googleMapConfig } from 'src/app-config';
import { GoogleMap, Polygon, useJsApiLoader } from '@react-google-maps/api';
import { houseToHouseServices } from 'src/services';
import { Modal } from 'react-bootstrap';
import { setAlertResponse, setValuesAndOpenAlertModalReducer } from 'src/store';
import { typeBlock, typeFace, typeHTHTerritory, typeTerritoryNumber } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useGetConfig, useGetCurrentPosition, useGetIsDarkMode, useGetIsMobile } from 'src/custom-hooks';
import { useNavigate } from 'react-router';

type propsType = {
    closeModal: () => void;
};

export const GeoLocationModal: FC<propsType> = ({ closeModal }) => {
    const [hthTerritories, setHTHTerritories] = useState<typeHTHTerritory[] | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const config = useGetConfig();
    const currentPosition = useGetCurrentPosition(true, true);
    const dispatch = useDispatch();
    const isDarkMode = useGetIsDarkMode();
    const isMobile = useGetIsMobile();
    const mapLoader = useJsApiLoader(googleMapConfig);
    const navigate = useNavigate();

    const openModalHandler = (territoryNumber: typeTerritoryNumber, block: typeBlock, face: typeFace, street: string): void => {
        dispatch(setValuesAndOpenAlertModalReducer({
            mode: 'confirm',
            title: 'Confirmar',
            message: `Territorio ${territoryNumber} manzana ${block} calle ${street} (${face}). ¿Ir?`,
            execution: () => {
                navigate(`/casa-en-casa/${territoryNumber}?b=${block}&f=${face}`);
            }
        }));
    }

    useEffect(() => {
        houseToHouseServices.GetTerritoriesForMap().then(response => {
            setIsLoading(false);
            if (!response.success || !response.data?.hthTerritories) {
                dispatch(setAlertResponse({ response }));
                return;
            }
            setHTHTerritories(response.data.hthTerritories);
        });
    }, []);

    return (
        <Modal show fullscreen onHide={closeModal}>
            <Modal.Header className={isDarkMode ? 'bg-dark text-white' : ''} closeButton>
                <Modal.Title>
                    Tu posición: {isLoading ? '...' : currentPosition.address || 'No se obtuvo la ubicación actual'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className={isDarkMode ? 'bg-dark text-white' : ''}>
                {(isLoading || !mapLoader.isLoaded) ?
                    <Loading mt={'80px'} />
                    : !hthTerritories ?
                    <FailedToGetData />
                    :
                    <GoogleMap
                        center={currentPosition.userCoords ?? config.centralPointCoordinates ?? { lat: 0, lng: 0 }}
                        id={googleMapConfig.id}
                        mapContainerClassName={isMobile ? 'position-absolute' : 'd-block m-auto'}
                        mapContainerStyle={{
                            height: isMobile ? '600px' : '530px',
                            width: '95%'
                        }}
                        zoom={17.8}
                    >
                        {hthTerritories.map(t =>
                            <div key={t.territoryNumber}>
                                {t.faces.map(polygon =>
                                    <Polygon key={polygon.id}
                                        onClick={() => {
                                            openModalHandler(t.territoryNumber, polygon.block, polygon.face, polygon.street);
                                        }}
                                        options={{
                                            clickable: true,
                                            fillColor: generalBlue,
                                            fillOpacity: 0.9,
                                            strokeColor: '',
                                            strokeOpacity: 0.8,
                                            strokePosition: google.maps.StrokePosition.INSIDE,
                                            strokeWeight: 7
                                        }}
                                        path={[polygon.coordsPoint1, polygon.coordsPoint2, polygon.coordsPoint3]}
                                    />
                                )}
                            </div>
                        )}
                        {currentPosition.userCoords &&
                            <MapMarkerCurrentPosition
                                showError
                            />
                        }
                    </GoogleMap>
                }
            </Modal.Body>
        </Modal>
    );
}
